import { render, staticRenderFns } from "./moisture-threshold.vue?vue&type=template&id=4aef267c"
import script from "./moisture-threshold.vue?vue&type=script&lang=js"
export * from "./moisture-threshold.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports